



import Icon from '../../components/bases/icone/icon.js';

import AppBase from '../appBase.js';

import AppHeader from './appcomponents/appheader/appheader.js';

import ExportShowAssert from './appcomponents/exportscomponents/showasset.js';
import VideoPlayerTR from '../../components/bases/videoplayer/videoplayertr.js';
import AssetsManager from './appcomponents/assetsmanager/assetsmanager.js';
import ToolsBar from '../../components/bases/toolsbar/toolsbar.js';
import User from "./appcomponents/user/user.js"

import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import styles from "../appstyles/styles.module.css"

import { apiReadOneAsset, apiSearchAssetsFromProject, apiReadOneVideo} from '../../utils/apis.js';

import { keyboard_multi_getKey, keyboard_multi_getShorCutList_by_apps_and_keyboard } from '../../utils/keyboard_multi.js';

import { getVideoPath } from '../../utils/apis.js';
import {getCurrentProjectDatas} from "../../utils/software.js"

import { GlobalContext, UploadComponentRef } from '../../utils/globalprovider.js';

import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTTSmall.png"

import { AppExport_ExportType } from '../../utils/software.js';
import ExportType from './appcomponents/exportscomponents/exporttype.js';

import ExportTXTTR from './appcomponents/exportscomponents/exportfile/exportTRtxt/exporttxttr.js';
import ExportDOCXTR from './appcomponents/exportscomponents/exportfile/exportDocX/exportdocxtr.js';
import ExportTXTST from './appcomponents/exportscomponents/exportfile/exportSTtxt/exporttxtst.js';
import ExportN19 from './appcomponents/exportscomponents/exportfile/exportn19/exportn19.js';
import ExportTTML from './appcomponents/exportscomponents/exportfile/exportttml/exportttml.js';
import ExportSRT from './appcomponents/exportscomponents/exportfile/exportsrt/exportsrt.js';
import ExportDAIA from './appcomponents/exportscomponents/exportfile/exportDAIA/exportDAIA.js';
import ExportTXTMOSAIC from './appcomponents/exportscomponents/exportfile/exporttxtmosaic/exporttxtmosaic.js';
import ExportTRJson from './appcomponents/exportscomponents/exportfile/exportTRJson/exportTRJson.js';
import ExportTRPhrasesJson from './appcomponents/exportscomponents/exportfile/exportTRPhrasesJson/exportTRPhrasesJson.js';
import ExportSTJson from './appcomponents/exportscomponents/exportfile/exportSTJson/exportSTJson.js';
import PreviewTTML from './appcomponents/exportscomponents/preview/previewttml.js';
import PreviewSRT from './appcomponents/exportscomponents/preview/previewsrt.js';
import PreviewDAIA from './appcomponents/exportscomponents/preview/previewDAIA.js';
import PreviewTXT from './appcomponents/exportscomponents/preview/previewtxttr.js';
import PreviewDOCX from './appcomponents/exportscomponents/preview/previewdocxtr.js';
import PreviewTXTST from './appcomponents/exportscomponents/preview/previewtxtst.js';
import PreviewTXTMOSAIC from './appcomponents/exportscomponents/preview/previewtxtmosaic.js';


import React from "react";
import { configurations_getDefaultParams } from '../../utils/configurations.js';



function ResizeHandle({   className = "",   id })
{
 
  return (
    <PanelResizeHandle
      className={[styles.ResizeHandleOuter, className].join(" ")}
      id={id}
    >
      <div className={styles.ResizeHandleInner}>
      </div>
    </PanelResizeHandle>
  );
}





class AppExport extends AppBase
{
    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        

        this.shortcuts_list = [];

        this.state = {
          paramOpen: false,
          pjid: getCurrentProjectDatas().pjid,
          stparams: configurations_getDefaultParams(),

          currentExportType : AppExport_ExportType.notdefined , // non définie
          currentExportedAsset : -1, // asset qu'on exporte
          currentVideoAsset : -1, // asset dans le player video
          currentStAsset : -1, // asset sous-titre dans le player video
          currentExportFileFormat : -1, // format de fichier exporter

          currentTypeFormat: "", // type json, stl, 
          currentTitleFormat: "",
          
          
          
          videopath: null,
          videoready: false,
          videoforplayer: null,
          toolsbar:
          { 
            height: 20,
  
            items: [

            ],
          }

        }
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.onCancelKeyboardEvent = this.onCancelKeyboardEvent.bind(this);
        this.cancelKeyboardEvent = false;

        this.onClickToolsBar = this.onClickToolsBar.bind(this);


        this.videoPlayerRef = React.createRef();
        this.bodyDivRef = React.createRef();
        this.assetsManagerRef = React.createRef();

        // timeline
        this.toolsbarRef = React.createRef();
        
        this.transcriptRef = React.createRef();
        
        // temporary
        
        // preview
        this.previewRef = React.createRef();
        this.DisplayPreview = this.DisplayPreview.bind(this);

       
      
        // asset manager
        this.onClickOnAsset = this.onClickOnAsset.bind(this)
        this.onAssetsManagerChange = this.onAssetsManagerChange.bind(this)

        this.apicallbackReadVideo = this.apicallbackReadVideo.bind(this);
        this.apicallbackReadSubtitlesForPlayer = this.apicallbackReadSubtitlesForPlayer.bind(this);



        this.playerparams = 
        {
            background: false,
            displaytc: true,
            displaytcms: true,
            dontscale: true,
        }


        
        
        this.initialised =  false;
        this.state.assetsList = [];



        this.currentOriginalTranscriptId = 0;
        this.currentCorrectedTranscriptId = 0;
        this.currentCalculedSubtitlesId = 0;
        this.currentCorrectedSubtitlesId = 0;
        this.currentFinalTranscriptionId = 0;
        


        this.V3_FirstassetsDownloaded =  false;
        this.V3_FirstDownloadProjectAssets  = this.V3_FirstDownloadProjectAssets.bind(this) // fonction appellée dans component did mout
        this.V3_OpenFirstAsset = this.V3_OpenFirstAsset.bind(this);
        
        
        this.V2_ExistAsset = this.V2_ExistAsset.bind(this)

        this.onchangeformat = this.onchangeformat.bind(this)


      }  

    canClose()
    {
        return true;
      
    }
    
  

    getCurrentDate = () => {
      const today = new Date();
    
      const year = today.getFullYear(); // Année AAAA
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
      const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
    
      return `${year}/${month}/${day}`;
    };

    generateUUID() 
  {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant 1

    return [...array].map((byte, index) => {
        const hex = byte.toString(16).padStart(2, '0');
        return ([4, 6, 8, 10].includes(index) ? '-' : '') + hex;
    }).join('');
  }

    
    componentDidMount() 
    {

      this.shortcuts_list =keyboard_multi_getShorCutList_by_apps_and_keyboard(["player"]);
      window.addEventListener('keydown', this.handleKeyDown);

      if (this.initialised) return;
      this.initialised = true;
        

     
      this.V3_FirstDownloadProjectAssets(); // C'est parti

      

    }

    onchangeformat(format, type, title)
    {

          
          

          if (this.state.currentExportType !== type)
            this.setState ({currentExportType: type, currentTitleFormat: title})
      
    }


    //  **********************************************************************
    //  * Messages assets manager
    //  **********************************************************************


    onClickOnAsset(asset)
    {
        
        switch (asset.astype)
        {
            
            case 3: // c'est une video
            this.setState(
              {
              currentExportType : AppExport_ExportType.video , // non définie
              currentExportedAsset : asset.asid, // asset qu'on exporte
              currentVideoAsset : asset.asid, // asset dans le player video
              currentExportFileFormat : AppExport_ExportType.video, // format de fichier exporter
              })


              this.setState({videopath: "", videoready: false, videoforplayer: null});  
              if (asset.asid > 0)
              {
                    var asset = this.V3_GetAssetFromID(this.state.assetsList, asset.asid);
                    var datas = {viid: asset.asviid};
                    apiReadOneVideo (datas, this.apicallbackReadVideo)   
                    
              }      
              var current = this.assetsManagerRef.current.getCurrent();
              current.originaltr = -1;
              current.correctedtr= -1;
              current.finaltr = -1;
              current.correctedsubtitle = -1;
              current.calculatedsubtitles = -1;
              this.assetsManagerRef.current.setNewCurrent( current );

        
              break;

            case 4:
            case 5:       
            
              if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
              {
                var current = this.assetsManagerRef.current.getCurrent();
                current.originaltr = -1;
                current.correctedtr= -1;
                current.finaltr = -1;
                current.correctedsubtitle = -1;
                current.calculatedsubtitles = -1;
                switch (asset.astype)
                {
                  case 4: current.calculatedsubtitles = asset.asid; break;
                  case 5: current.correctedsubtitle = asset.asid; break;
                  
                }
                this.assetsManagerRef.current.setNewCurrent( current );
              }

              if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
                {
                    var datas = {asid: asset.asid};
                    apiReadOneAsset (datas, this.apicallbackReadSubtitlesForPlayer)
                }
  
            
            this.setState(
              {
              currentExportType : AppExport_ExportType.subtitle , // non définie
              currentExportedAsset : asset.asid, // asset qu'on exporte
              currentExportFileFormat : AppExport_ExportType.subtitle, // format de fichier exporter
              })
              break;



            case 1:
            case 2:
            case 6:
                var currentStAsset = -1;
              // c'est un transcription on va chercher un sous-titrage qui correspond
              // on regarde si on a des st corrigés pour cette transcription
              var assetsearch = this.V3_CorrectedFromOriginal(this.state.assetsList, asset.asid, 5 );
              if (assetsearch.asid < 1)
              {
                  assetsearch = this.V3_CorrectedFromOriginal(this.state.assetsList, asset.asid, 4 );                
                  if (assetsearch.asid  > 0 )
                      currentStAsset  = assetsearch.asid;
              }
              else
                currentStAsset = assetsearch.asid;

              if ((currentStAsset>0) && (this.videoPlayerRef) && (this.videoPlayerRef.current))
              {
                  var datas = {asid: currentStAsset};
                  apiReadOneAsset (datas, this.apicallbackReadSubtitlesForPlayer)
              }
              if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
              {
                var current = this.assetsManagerRef.current.getCurrent();
                current.originaltr = -1;
                current.correctedtr= -1;
                current.finaltr = -1;
                current.correctedsubtitle = -1;
                current.calculatedsubtitles = -1;
                switch (asset.astype)
                {
                  case 1: current.originaltr = asset.asid; break;
                  case 2: current.correctedtr = asset.asid; break;
                  case 6: current.finaltr = asset.asid; break;
                }
                this.assetsManagerRef.current.setNewCurrent( current );
              }
              this.setState(
                {
                  currentStAsset: currentStAsset,
                  currentExportType : AppExport_ExportType.transcription , // non définie
                  currentExportedAsset : asset.asid, // asset qu'on exporte
                  currentExportFileFormat : AppExport_ExportType.transcription, // format de fichier exporter
                })
                break;
            }  

        

                
      
    }


    
    //  **********************************************************************
    //  * l'asset manager a rechargé sa liste d'assets
    //  **********************************************************************
    onAssetsManagerChange(datas)
    {
     this.setState({assetsList : datas});
      
    }




    // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() 
    {
      window.removeEventListener('keydown', this.handleKeyDown);
    }  
      
    
    handleKeyDown = (event) =>
    {
      
      if (this.cancelKeyboardEvent) return;
      
      if (this.videoPlayerRef)
      {
        if (this.videoPlayerRef.current.keyboard_multi_gereKeyBoard(this.shortcuts_list, event.key, event.shiftKey, event.ctrlKey, event.altKey))
        {
          event.preventDefault();
          return;
        }
      }


    }
    

 
  onClickToolsBar(datas)
  {
    
    switch (datas.cat)
    {
      default:
        break;
    }
  }

  onCancelKeyboardEvent(value)
  {
    
    this.cancelKeyboardEvent =  value;
  }


  DisplayPreview(datas)
  {
    if ((this.previewRef) && (this.previewRef.current))
      this.previewRef.current.setFile(datas);
  }

  render ()
  {

    var apptitle = "EXPORTS";
    
    // https://neweasysubdatas.easydirect.fr/videos/BR0217LN_EasySub.mp4


    var ExportBase = (<></>)
    
    if (this.state.currentExportedAsset>0)
    {
      switch (this.state.currentExportFileFormat)
      {
          case AppExport_ExportType.subtitle:
          {
            switch (this.state.currentExportType)
            {
                case "stl0":
                  ExportBase = (<ExportN19  key={this.state.currentExportType} stoponerror = {true} displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
                case "stl1":
                  ExportBase = (<ExportN19  key={this.state.currentExportType} stoponerror = {false} displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
                case "ttml1":
                  ExportBase = (<ExportTTML assetsList = {this.state.assetsList} displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
                case "srt1":
                  ExportBase = (<ExportSRT displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
                case "json1":
                  ExportBase = (<ExportSTJson displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
              case "txt1":
                ExportBase = (<ExportTXTST displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;


            }
          }
          break;
          
          case AppExport_ExportType.transcription:
          {
            switch (this.state.currentExportType)
            {
              case "txt1":
                ExportBase = (<ExportTXTTR displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;
            
              case "json0":
                ExportBase = (<ExportDAIA displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;

              case "json1":
                ExportBase = (<ExportTRJson displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;

                case "json2":
                ExportBase = (<ExportTRPhrasesJson displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;
              case "docx1":
                ExportBase = (<ExportDOCXTR assetsList = {this.state.assetsList} displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;
              case "txt2":
                ExportBase = (<ExportTXTMOSAIC displaypreview = {this.DisplayPreview} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;

              }

              
        }
      }
    }    


    var exportPreview = (<></>);
    if (this.state.currentExportedAsset>0)
    {
      switch (this.state.currentExportFileFormat)
      {
          case AppExport_ExportType.subtitle:
          {
            switch (this.state.currentExportType)
            {

                case "ttml1":
                  exportPreview = (<PreviewTTML ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
                case "srt1":
                  exportPreview = (<PreviewSRT ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;
                case "json1":
                  exportPreview = (<PreviewDAIA ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;
                case "txt1":
                  exportPreview = (<PreviewTXTST ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;

              
                }
            break;
          }
          case AppExport_ExportType.transcription:
          {
            switch (this.state.currentExportType)
            {
                
                case "txt1":
                  exportPreview = (<PreviewTXT ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;

                case "txt2":
                  exportPreview = (<PreviewTXTMOSAIC ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;

                  case "docx1":
                  
                  exportPreview = (<PreviewDOCX ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                  break;

                case "json0":
                case "json1":
                case "json2":
                  exportPreview = (<PreviewDAIA ref={this.previewRef} asid={this.state.currentExportedAsset} format={this.state.currentExportFileFormat} type={this.state.currentExportType} title={this.state.currentTitleFormat}/>)
                break;
              }
          }
      }
    }    
  
   
    return (
      <div className={styles.appDiv}  tabIndex={0} id="AppTranscriptContainer">
        <div className={styles.appDivTop}>
          <div className={styles.appDivLogoFtva}>
              <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
          </div>
 <        div className={styles.appDivProject}>
              <div className={styles.appDivProjectLeft}>
              <h1>{apptitle}</h1>
              </div>
              <div className={styles.appDivProjectRight}>
              <AppHeader onCancelKeyboardEvent={this.onCancelKeyboardEvent} ref={this.appHeaderRef} canclose={false} canedit={true}/>
              </div>

          </div>
        <div className={styles.appDivLogo}>
          <Icon image={easytt} height="100%" width="100%"/>
          </div>
          <div className={styles.appDivUser}>
          <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
          </div>
        </div>
        <div className={styles.appDivToolsBar}>
            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar}/>
        </div>
        <div className={styles.appDivBody} ref = {this.bodyDivRef}>
          
          <div className={styles.appPanelsContainerExport} 
            div tabIndex={1} 
            style = {{outline:"none"}}
            >

          
          
            
            <PanelGroup direction="vertical">
            <Panel>
                <PanelGroup direction="horizontal">
                    <Panel className={styles.appPanel} defaultSize={20}>
                        <PanelGroup direction="vertical" >
                            <Panel className={styles.appPanelBorder} defaultSize={65} >
                            <div className={styles.apptitleexport}>Asset Manager</div>
                            <AssetsManager 
                                pjid={this.state.pjid}
                                mode = "transcript"
                                nodelete = {true}
                                onCancelKeyboardEvent = {this.onCancelKeyboardEvent}
                                onClick = {this.onClickOnAsset}
                                onChange = {this.onAssetsManagerChange}
                                ref={this.assetsManagerRef}/>
                             </Panel>
                            <ResizeHandle />
                            <Panel className={styles.appPanelBorder}  >
                            <VideoPlayerTR ref={this.videoPlayerRef} 
                                onNewTime={this.onNewTime}
                                onready={this.VideoReady}
                                params= {this.playerparams}
                                stparams = {this.state.stparams}
                                src = {this.state.videopath}
                                video = {this.state.videoforplayer}
                                />
                            </Panel>
                        </PanelGroup>
                    </Panel>
                    <ResizeHandle />
              
                    <Panel className={styles.appPanelBorder} defaultSize={20}>
                      <div className={styles.apptitleexport}>{this.context.language=="fr"?"Fichier Exporté":"File to Export"}</div>
                      <ExportShowAssert
                            fileformat = {this.state.currentExportFileFormat}
                            assetid = {this.state.currentExportedAsset} 
                            asset = {this.V3_GetAssetFromID(this.state.assetsList, this.state.currentExportedAsset)}
                      />
                        
                    </Panel>
                    <ResizeHandle />
                    <Panel className={styles.appPanel}  defaultSize={30}>
                        <PanelGroup direction="vertical" >
                            <Panel className={styles.appPanelBorder} defaultSize={25}>
                            <div className={styles.apptitleexport}>{this.context.language=="fr"?"Format d'exportation":"Export Format"}</div>
                            <ExportType
                              onclick={this.onchangeformat}
                              type = {this.state.currentExportFileFormat}/>
                            </Panel>
                            <ResizeHandle />
                            <Panel className={styles.appPanelBorder}>
                            <div className={styles.apptitleexport}>{this.context.language=="fr"?"Paramètre d'exportation":"Export Settings"}</div>
                            {ExportBase}
                            </Panel>
                        </PanelGroup>
                    </Panel>

                    <ResizeHandle />
              
                    <Panel className={styles.appPanelBorder} defaultSize={30}>
                    <div className={styles.apptitleexport}>Preview Export</div>
                    {exportPreview}
                        
                    </Panel>

                </PanelGroup>
              </Panel>
              </PanelGroup>
            </div>
          
          </div>
          
      </div>
    
    )
    }



    
    // *************************************************************************************************************
    // Nouvelle gestion d'ouverture de transcription (diverses functions)
    // *************************************************************************************************************

    V3_FirstDownloadProjectAssets()
    {
      if (this.V3_FirstassetsDownloaded) return;
      

      if (this.state.pjid !== 0)
        apiSearchAssetsFromProject({pjid: this.state.pjid}, this.V3_OpenFirstAsset); // C'est le grand départ
      this.V3_FirstassetsDownloaded = true;


      /*
      currentExportType : AppExport_ExportType.notdefined , // non définie
      currentExportedAsset : -1, // asset qu'on exporte
      currentVideoAsset : -1, // asset dans le player video
      currentStAsset : -1, // asset sous-titre dans le player video
      currentExportFileFormat : -1, // format de fichier exporter
      */


    }

    V3_OpenFirstAsset(datas)
    {
      this.setState({assetsList: datas});; // viennent de V3_FirstDownloadProjectAssets
      // on recherche si on a une video
      this.state.assetsList = datas;
      var assetvideo = this.V3_GetAssetByType(this.state.assetsList, 3) ;

      var currentStAsset = -1;
      var currentVideoAsset = -1;
      var currentExportType = AppExport_ExportType.notdefined;
      var currentExportedAsset = -1;

      if (assetvideo.asid != 0)
      {
        currentVideoAsset = assetvideo.asid;
          
          
      }

      // on cherche l'export par default

      
      var assetsearch; 
      if (currentExportType === AppExport_ExportType.notdefined)
      {
          // on cherche si on peut exporter un fichier de sous titre corrigé
          assetsearch = this.V3_GetAssetByType(this.state.assetsList,5) ;
          if (assetsearch.asid != 0)
          {
            currentExportedAsset = assetsearch.asid;
            currentExportType = AppExport_ExportType.subtitle;
          }
      }

      if (currentExportType === AppExport_ExportType.notdefined)
      {
          // on cherche si on peut exporter un fichier de transcription corrigée
          assetsearch = this.V3_GetAssetByType(this.state.assetsList, 2) ;
          if (assetsearch.asid != 0)
          {
            currentExportedAsset = assetsearch.asid;
            currentExportType = AppExport_ExportType.transcription;
          }
      }
  
      if (currentExportType === AppExport_ExportType.notdefined)
      {
          // on cherche si on peut exporter un fichier de sous-titre calculé
          assetsearch = this.V3_GetAssetByType(this.state.assetsList, 4) ;
          if (assetsearch.asid != 0)
          {
            currentExportedAsset = assetsearch.asid;
            currentExportType = AppExport_ExportType.subtitle;
          }
      }
  

      if (currentExportType === AppExport_ExportType.notdefined)
      {
          // on cherche si on peut exporter un fichier de transcription originale
          assetsearch = this.V3_GetAssetByType(this.state.assetsList, 1) ;
          if (assetsearch.asid != 0)
          {
            currentExportedAsset = assetsearch.asid;
            currentExportType = AppExport_ExportType.transcription;
          }
      }
  

      if (currentExportType === AppExport_ExportType.notdefined)
      {
          // on cherche si on peut exporter un fichier de sous-titre calculé
          assetsearch = this.V3_GetAssetByType(this.state.assetsList, 3) ;
          if (assetsearch.asid != 0)
          {
            currentExportedAsset = assetsearch.asid;
            currentExportType = AppExport_ExportType.video;
          }
      }


  

      // on cherche un fichier de sous-titres qui fait l'affaire
      if (currentExportType === AppExport_ExportType.subtitle)
      {
          currentStAsset = currentExportedAsset.asid;
      }
      else
      {
        if (currentExportType === AppExport_ExportType.transcription)
        {
              // on regarde si on a des st corrigés
              assetsearch = this.V3_CorrectedFromOriginal(this.state.assetsList, currentExportedAsset, 5 );
              if (assetsearch.asid < 1)
              {
                  assetsearch = this.V3_CorrectedFromOriginal(this.state.assetsList, currentExportedAsset, 4 );                
                  if (assetsearch.asid  > 0 )
                      currentStAsset  = assetsearch.asid;
              }
              else
                currentStAsset = assetsearch.asid;
        }
      }

      

      // on informe l'asset manager

      var current =
      {
        video: 0,
        originaltr: 0,
        correctedtr: 0,
        calculatedsubtitles: 0,
        correctedsubtitle: 0,
        finaltr: 0,                    
      }

      if (currentExportedAsset > 0)
      {
          assetsearch = this.V3_GetAssetFromID(this.state.assetsList, currentExportedAsset)
          switch(assetsearch.astype)
          {
            case 1:
                current.originaltr = currentExportedAsset;
                break;
            case 2:
                current.correctedtr = currentExportedAsset;
                break;
            case 3:
                current.video = currentExportedAsset;
                break;
            case 4:
                current.calculatedsubtitles = currentExportedAsset;
                break;
            case 5:
                current.correctedsubtitle = currentExportedAsset;
                break;
            case 6:
                current.finaltr = currentExportedAsset;
                break;
          }
      }

      if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
      {
          this.assetsManagerRef.current.setNewCurrent( current );
      }


      // on va en parler au player
      this.setState({videopath: "", videoready: false, videoforplayer: null});  
      if (currentVideoAsset > 0)
      {
            var asset = this.V3_GetAssetFromID(this.state.assetsList, currentVideoAsset);
            var datas = {viid: asset.asviid};
            apiReadOneVideo (datas, this.apicallbackReadVideo)   
            
            if (currentStAsset > 0)
            {

                // on lit le fichier de sous titre
                var datas = {asid: currentStAsset};
                apiReadOneAsset (datas, this.apicallbackReadSubtitlesForPlayer)

            }
      }      


      
      this.setState({
          currentExportType : currentExportType,
          currentExportedAsset : currentExportedAsset, // asset qu'on exporte
          currentVideoAsset : currentVideoAsset, // asset dans le player video
          currentStAsset : currentStAsset, // asset sous-titre dans le player video
          currentExportFileFormat : currentExportType, // format de fichier exporter
      });

    }

    apicallbackReadSubtitlesForPlayer (datas)
    {
      
      
      if (datas.ret)
        {
          
          if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
          {
            var subtitles = JSON.parse(datas.asdatas);
            this.videoPlayerRef.current.setNewSubtitles(subtitles.subtitles);
            if (subtitles.params)
              this.setState({stparams: subtitles.params});
            
          }
        }

    }
    apicallbackReadVideo(datas)
    {

      
        
        if (datas.length > 0)
        {
            const video = datas[0];
            const videofile = getVideoPath(video);
            this.setState({videopath: videofile, videoready: true, videoforplayer: video});
            

        }
    }



    V3_GetAssetByType (assets, type)
    {
      for (var i=0; i<assets.length; i++)
        if (assets[i].astype === type) return assets[i];
      return {asid:0};

    }

    V3_GetAssetFromID(assets, id)
    {
      if (id < 1) return {asid:0};
      for (var i=0; i<assets.length; i++)
        if (assets[i].asid === id) return assets[i];
      return {asid:0};

    }

    V2_ExistAsset (assets, id)
    {
        if (id < 1) return false;
        for (var i=0; i<assets.length; i++)
          if (assets[i].asid === id) return true;
        return false;
    }

    V3_CorrectedFromOriginal(assets, original, type)
    {
      
      if (original < 1) return false;
      for (var i=0; i<assets.length; i++)
        if ((assets[i].astype === type) && (assets[i].asoriid === original)) return assets[i];
      return {asid:0};
    }

    V2_SearchFirstTranscriptionByType(assets, type)
    {
      for (var i=0; i<assets.length; i++)
        if (assets[i].astype === type) return assets[i].asid;
      return 0;

    }
  }
export default AppExport;
